import React from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';

const Tabs = TabsPrimitive.Root;

const TabsList = React.forwardRef(({ className = '', ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={`
      inline-flex h-10 items-center justify-center rounded-md bg-slate-100 p-1 text-slate-500
      ${className}
    `}
    {...props}
  />
));
TabsList.displayName = TabsPrimitive.List.displayName;

const TabsTrigger = React.forwardRef(({ className = '', ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={`
      inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 
      text-sm font-medium ring-offset-white transition-all focus-visible:outline-none 
      focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2 
      disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-white 
      data-[state=active]:text-slate-950 data-[state=active]:shadow-sm
      ${className}
    `}
    {...props}
  />
));
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

const TabsContent = React.forwardRef(({ className = '', ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={`
      mt-2 ring-offset-white focus-visible:outline-none focus-visible:ring-2 
      focus-visible:ring-slate-950 focus-visible:ring-offset-2
      ${className}
    `}
    {...props}
  />
));
TabsContent.displayName = TabsPrimitive.Content.displayName;

export { Tabs, TabsList, TabsTrigger, TabsContent };
